<template>
  <div class="order-detail">
    <div class="title">
      <div class="icon"></div>
      <span>报名详情</span>
    </div>
    <van-form input-align="right">
      <van-field label="赛事名称" readonly>
        <template #input>
          {{ detail.matchName }}
        </template>
      </van-field>
      <van-field label="组别名称" readonly>
        <template #input>
          {{ detail.matchGroup }}
        </template>
      </van-field>
      <van-field label="球队名称" readonly>
        <template #input>
          {{ detail.teamName }}
        </template>
      </van-field>
      <van-field label="队员名称" readonly>
        <template #input>
          {{ detail.playerName }}
        </template>
      </van-field>
    </van-form>
    <div class="title">
      <div class="icon"></div>
      <span>支付详情</span>
    </div>
    <van-form input-align="right">
      <van-field label="付款方式" readonly>
        <template #input>
          {{ getType(detail.feeMethod) }}
        </template>
      </van-field>
      <van-field label="付款说明" readonly v-model="detail.orderId"></van-field>
      <van-field label="付款金额" readonly>
        <template #input>
          ¥{{ (detail.userPayment / 100).toFixed(2) }}
        </template>
      </van-field>
    </van-form>
    <div class="title">
      <div class="icon"></div>
      <span>订单详情</span>
    </div>
    <van-form input-align="right">
      <van-field label="订单编号" readonly v-model="detail.orderId">
        <template #input>
          {{ getType(detail.feeMethod) }}
        </template>
      </van-field>
      <van-field label="下单时间" readonly>
        <template #input>
          {{ getFormatDate(detail.createDate, '{y}-{m}-{d} {h}:{i}') }}
        </template>
      </van-field>
      <van-field label="付款状态" readonly>
        <template #input>
          <span v-if="detail.orderStatus === 0">待支付</span>
          <span v-else-if="detail.orderStatus === 1">
            <span v-if="detail.refundApplyStatus === 0">发起退款</span>
            <span v-else-if="detail.refundApplyStatus === -1">拒绝退款</span>
            <span v-else-if="detail.refundApplyStatus === 1">退款失败</span>
            <span v-else-if="detail.refundApplyStatus === -2">已支付</span>
          </span>
          <span v-else-if="detail.orderStatus === 2">
            <span v-if="detail.refundStatus === 4">退款失败</span>
            <span v-else>退款中</span>
          </span>
          <span v-else-if="detail.orderStatus === 3">已退款</span>
          <span v-else>--</span>
        </template>
      </van-field>
    </van-form>
    <div style="height: 115px; background-color: #F6F6F8;"></div>
    <div class="bottom" v-if="detail.orderStatus === 0">
      <van-button type="info" block @click="bangsaishiCheckTeamSignupOrder"
        style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">支 付</van-button>
    </div>
  </div>
</template>

<script>
import { getOrderDetail, getWechatPrepayInfo,bangsaishiCheckTeamSignupOrder,bangsaishiCreateTeamSignupOrder } from "@/api/match";
import { DateUtil, UrlUtil, isWeChatMiniApp } from "@/utils";
import { feeMethodOptions } from "@/config";
import Vue from 'vue'
import { Form, Field, Button } from "vant";
import { getWXInfo, removeToken } from "@/libs/cookie-storage";
import { AppType } from "@/constants/appType";
import { ConstConfig } from "@/constants";
Vue.use(Form).use(Field).use(Button)
import wx from 'weixin-js-sdk'

export default {
  name: "order-detail",
  data() {
    return {
      detail: {},
      orderId: '',
      unionMatchId: '',
      matchId: '',
      teamId: ''
    }
  },
  mounted() {
    this.orderId = this.$route.params.orderId
    this.unionMatchId = this.$route.query.unionMatchId
    this.getOrderDetail()
  },
  methods: {
    getType(type) {
      const obj = feeMethodOptions.find(f => f.value === type)
      if (!obj) return '--'
      return obj.label
    },
    getOrderDetail() {
      const params = {
        orderId: this.orderId
      }
      getOrderDetail(params).then(res => {
        if (res) {
          const { data } = res
          this.detail = data
          const objId = data.objId.split('%')
          this.matchId = objId[0]
          this.teamId = objId[1]
        }
      })
    },
    getFormatDate(date, type) {
      if (!type) type = '{y}-{m}-{d}'
      return DateUtil.parseDateTime(date, type)
    },
    pay() {
      if (AppType.isInWeChat()) {// 微信环境
        isWeChatMiniApp().then(res => {
          if (res) { // 小程序环境
            this.miniAppPayOrder(this.orderId)
          } else { // 微信H5环境
            this.getWechatPrepayInfo()
          }
        })
      } else {
        this.$toast('请在微信环境打开')
      }
    },
     bangsaishiCheckTeamSignupOrder() {
      bangsaishiCheckTeamSignupOrder({ orderId: this.orderId }).then(res => {
        if (res) {
          const { data } = res
          if (data.checkPrice) {
            this.pay()
          } else {
            bangsaishiCreateTeamSignupOrder({matchId:this.matchId,teamId:this.teamId}).then(res=>{
              if(res){
                this.orderId = res.data.orderId
                this.pay()
              }
            })
          }
        }
       })
    },
    getWechatPrepayInfo() {
      const wxInfo = getWXInfo()
      if (!wxInfo?.openId) {
        if (AppType.isInWeChat()) {
          removeToken()
          this.$toast('请刷新页面后重试')
          return
        } else {
          this.$toast('请在微信环境打开')
          return
        }
      }
      const data = {
        orderId: this.orderId,
        openId: wxInfo.openId,
        realPay: 1
      }
      getWechatPrepayInfo(data).then(res => {
        this.hrefWechatPay(res.data.payInfo.payInfo, this.orderId)
      })
    },
    // 调起支付
    hrefWechatPay(payInfo) {
      const role = this.category === 0 ? 1 : 0
      const payUrl = ConstConfig.payUrl + '?' + UrlUtil.queryObjectToString({
        t: Date.now(),
        payInfo: JSON.stringify(payInfo),
        redirectUrl: `${process.env.VUE_APP_BM_MATCH}#/entry-page/entry-list/?unionMatchId=${this.unionMatchId}&role=${role}`
      })
      window.location.assign(payUrl)
    },
    miniAppPayOrder(orderId) {
      const url = `/pages/pay/index?orderId=${orderId}&redirectUrl=${encodeURIComponent(this.redirectUrl)}`
      wx.miniProgram.navigateTo({ url })
    },
  }
};
</script>

<style lang="scss" scoped>
.order-detail {
  min-height: 100vh;
  background-color: #F8F8F8;

  .title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    padding: 12px 0 13px 0;
    margin: 0 16px;
    border-bottom: 0.5px #EEEEEE solid;

    .icon {
      width: 2px;
      height: 12px;
      background-color: #7CCD19;
      margin-right: 6px;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }
}</style>
